/***暂停视频和音频播放**/
export function handlePauseUtil(tag) {
    let content = document.getElementById(tag);
    if(content){
      const audioList = content.getElementsByTagName('audio');
      const videoList = content.getElementsByTagName('video');
      for(let i=0;i<audioList.length;i++) {
        audioList[i].pause();
      }
      for(let i=0;i<videoList.length;i++) {
        videoList[i].pause();
      }
    }
  }
  export function getInputSortUtil(flows) {
    if (flows && flows.length > 0) {
      flows.forEach(item => {
        const domList = document.querySelectorAll(`[name="${item.tagId}"]`);

        if (item.tagId && item.tagId.includes("text")) {
          // 仅针对真实的 input 元素做替换，避免命中 addAnswer 生成的展示用 span
          const tag = [...domList].find(el => el.tagName === "INPUT");
          if (tag) {
            const parent = tag.parentNode;
            const n = document.createElement("span");
            n.style.borderBottom = `1px solid blue`;
            n.innerHTML = `${item.questionNumber}(${item.answer})`;
            // tag.setAttribute("placeholder",`${item.sort}(${item.answer})`);
            parent.replaceChild(n, tag);
          }
        }
        if (domList && domList.length > 0) {
          // 大题含多个小题：answer 形如 "B#B#A#B#B"，按 # 分割，逐小题默认选中
          if (item.answer && item.answer.includes("#")) {
            const answerArr = item.answer.split("#");
            // 从 DOM 中按出现顺序收集所有 radio 分组名称，避免依赖“名称按数字递增”的假设
            // （听说一体卷第二大题等场景，小题 radio 名称未必严格连续递增，按文档顺序取最稳妥）
            const radioNames = [];
            document
              .querySelectorAll('input[type="radio"]')
              .forEach(r => {
                if (radioNames.indexOf(r.name) === -1) {
                  radioNames.push(r.name);
                }
              });
            let tagIdList = [];
            const startIdx = radioNames.indexOf(item.tagId);
            if (startIdx !== -1) {
              // 优先：以当前大题首小题 tagId 为起点，按文档顺序取后续小题名称
              for (let k = 0; k < answerArr.length; k++) {
                tagIdList.push(radioNames[startIdx + k]);
              }
            } else {
              // 兜底：无法在 DOM 中找到该 tagId 时，退回按数字递增推导
              for (let k = 0; k < answerArr.length; k++) {
                if (k === 0) {
                  tagIdList.push(item.tagId);
                } else {
                  tagIdList.push(
                    item.tagId.replace(/\d+/g, match =>
                      String(Number(match) + k)
                    )
                  );
                }
              }
            }
            answerArr.forEach((ans, idx) => {
              const name = tagIdList[idx];
              if (ans && name) {
                const radio = document.querySelector(
                  `input[type="radio"][name="${name}"][value="${ans}"]`
                );
                if (radio) radio.checked = true;
              }
            });
          } else if (domList.length > 1) {
            // 单题/多选题：answer 为单个字母或多个字母（如 "AB" 表示多选）
            for (let j = 0; j < domList.length; j++) {
              const tag = domList[j];
              if (
                tag.type === "radio" &&
                item.answer &&
                item.answer.toUpperCase().includes(tag.value)
              ) {
                tag.checked = true;
              }
            }
          }
        }
      });
      // 选择题选项默认不可手动点击，仅展示根据答案选中的状态
      const allRadios = document.querySelectorAll('input[type="radio"]');
      for (let i = 0; i < allRadios.length; i++) {
        allRadios[i].disabled = true;
      }
    }
}
export function getAudioUtil(paper, fontSize = 14) {
    const domList = document.querySelectorAll(`audio`);
  
    if (domList && domList.length > 0) {
      if (paper.listeningText !== null && paper.listeningText !== "" && paper.showListening === 1) {
        let regex = new RegExp(/<p.*?(?:>|\/>)/gi); // 匹配所有行元素
        let arrsP = paper.listeningText.match(regex); // obj.info 后台返回的富文本数据
        if (arrsP === null) {
          const lines =
            paper.listeningText && paper.listeningText !== ""
              ? paper.listeningText.split("#")
              : [];
          for (let i = 0; i < domList.length; i++) {
            const tag = domList[i];
            const parent = tag.parentNode;
            const newNode = document.createElement("div");
            newNode.innerHTML = lines[i]
              ? `<span style="color: #409EFF;font-size: ${fontSize}px">听力原文：${
                  lines[i]
                }</span>`
              : "";
            parent.after(newNode);
          }
        } else {
          // let mapTag = getMapTag(paper.listeningText);
          for (let i = 0; i < domList.length; i++) {
            const tag = domList[i];
            const parent = tag.parentNode;
            if (paper.showListening === 1) {
              const newNode = document.createElement("div");
              newNode.style.color = "#409EFF";
              newNode.innerHTML = paper.listeningText
                ? `<span style="color: #409EFF;font-size: ${fontSize}px">听力原文：</span>${
                    paper.listeningText
                  }`
                : "";
              parent.after(newNode);
              break; // 如果是富文本，通常只在第一个音频后显示全部，或者需要更复杂的逻辑。
              // 既然 getMapTag 丢失了，我们先保证能显示出来。
            }
          }
        }
      }
    }
}
  /**排序**/
export function arraySort(property) {
    return function(a, b) {
      return a[property] - b[property];
    };
  }